import React from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { Select } from '../../components';

import css from './FieldSelect.css';

const FieldSelectComponent = props => {
  const { rootClassName, className, id = null, label = null, input, meta, children, markRequired, ...rest } = props;

  if (label && !id) {
    throw new Error('id required when a label is given');
  }

  const { valid, invalid, touched, error } = meta;

  // Error message and input error styles are only shown if the
  // field has been touched and the validation has failed.
  const hasError = touched && invalid && error;

  const selectProps = { id, ...input, ...rest };

  const classes = classNames(rootClassName || css.root, className);
  return (
    <div className={classes}>
      <Select {...selectProps} label={label} error={ hasError } markRequired={markRequired}>{children}</Select>
    </div>
  );
};

const FieldSelect = props => {
  return <Field component={FieldSelectComponent} {...props} />;
};

export default FieldSelect;
